import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import VueApexCharts from 'vue-apexcharts'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/style.css'
import './assets/css/header-footer.css'
import './assets/css/dashboard.css'
import VueAutosuggest from "vue-autosuggest";

// import './assets/css/login.css'
import './assets/css/common_chat.css'
Vue.config.productionTip = false
window.moment = moment;
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Notifications)
Vue.use(VueApexCharts)
Vue.use(Vuelidate)
Vue.use(VueAutosuggest);
Vue.filter('FormatDate', function (date, format) {
  return moment(date).format(format);
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
